import React, { Component } from 'react';
import { withNamespaces } from "react-i18next";
import { Icon } from '@iconify/react';
// import { default as ReactSelect } from "react-select";

//Miscellaneous
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

const options = [
  { value: "game0", label: "Select a Game Venue" },
  { value: "game1", label: "Game One" },
  { value: "game2", label: "Game Two" },
];

class MobileCommisionSimulator extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }
    
    render() 
    {
        const { t } = this.props;
        
        return (
            <Auxiliary>
                <div className="quota-deposit-container">
                    <form className="forms-col needs-validation" method="post" id="comm_form" onSubmit={this.props.submitHandler} noValidate>
                        <div className="pd-form-m-col">
                            <div>
                                <label>
                                    <span className="text-danger">*</span> {t('commission-illustrate.total-win-lose')} (USD)
                                </label>
                                <div className="input-group-col">
                                    <div className="input-group right has-validation">
                                        <NumberInput
                                            className="form-control p-0"
                                            placeholder={t('commission-illustrate.total-win-lose')}
                                            onChange={(event) => this.props.onInputChangeHandler(event)}
                                            name="total_win_lose"
                                            id="total_win_lose"
                                            value={this.props.total_win_lose}
                                            required={true}
                                            requiredMessage={t("validation.required")}
                                        />
                                    </div>
                                    <hr className="my-0" />
                                </div>
                            </div>

                            <div>
                                <label>
                                    <span className="text-danger">*</span> {t('commission-illustrate.downline-total-win-lose')} (USD)
                                </label>
                                <div className="input-group-col">
                                    <div className="input-group right has-validation">
                                        <NumberInput
                                            className="form-control p-0"
                                            placeholder={t('commission-illustrate.downline-total-win-lose')}
                                            onChange={(event) => this.props.onInputChangeHandler(event)}
                                            name="downline_total_win_lose"
                                            id="downline_total_win_lose"
                                            value={this.props.downline_total_win_lose}
                                            required={true}
                                            requiredMessage={t("validation.required")}
                                        />
                                    </div>
                                    <hr className="my-0" />
                                </div>
                            </div>
                            <div>
                                <label>
                                    {t('commission-illustrate.min-active-member')}
                                    <input
                                        id="min_member"
                                        name="min_member"
                                        style={{marginLeft: '2px'}}
                                        className="form-check-input"
                                        onChange={(event) => this.props.onInputChangeHandler(event)}
                                        type="checkbox"
                                        onClick={(event)=>event.stopPropagation()}
                                    />
                                </label>
                            </div>
                            <div>
                                <label>
                                    {t('commission-illustrate.commission-percentage')}
                                </label>
                                <div className="input-group-col">
                                    <div className="input-group right has-validation">
                                        <input
                                            className="form-control p-0"
                                            type="text"
                                            value={`${this.props.comm_percentage}%`}
                                            readOnly
                                        />
                                    </div>
                                    <hr className="my-0" />
                                </div>
                            </div>
                            <div>
                                <label>
                                    <span className="text-danger">*</span> {t('commission-illustrate.commission')} ({this.props.currentUser.currency})
                                </label>
                                <div className="input-group-col">
                                    <div className="input-group right has-validation">
                                        <input
                                            className="form-control p-0"
                                            type="text"
                                            value={this.props.payout}
                                            readOnly
                                        />
                                    </div>
                                    <hr className="my-0" />
                                </div>
                            </div>
                            {this.props.payout !== '' &&
                            <small style={{color: 'red', padding: '1rem'}}>
                                {t('commission-illustrate.sample-calculation')}: (({this.props.total_win_lose} * {this.props.comm_percentage}%) + (({this.props.downline_total_win_lose} * {this.props.downline_comm_percentage}%) * {this.props.level_comm_percentage}%)) * {this.props.exchange_rate}
                            </small>
                            }
                        </div>
                        <button type="submit" className="btn btn-gradient-blue mx-3">
                            {t('global.submit')}
                        </button>
                    </form>
                    <div className='px-3'>
                        <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" />{t('commission-illustrate.agent-comm-notice-7', {exchange_rate: this.props.exchange_rate})}</p>
                    </div>
                </div>
            </Auxiliary>
        )
    }
}

export default withNamespaces("translation")(MobileCommisionSimulator);